import IconButton from '@material-ui/core/IconButton';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import RefreshIcon from '@material-ui/icons/Refresh';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip'
import { useActions, useValues } from 'kea';
import { Typography } from '@material-ui/core';

import { assetmaplogic, preferenceslogic, assetreplaylogic, assetinfowindowlogic } from 'src/store/global';
import assetlogic from 'src/store/asset';

const ActionButtons = ({ row }) => {

	const { assets } = useValues(assetmaplogic);
	const { addOne, removeOne } = useActions(assetmaplogic);
	const { fetchUpdatedPosition, setHistory } = useActions(assetlogic);

	const { set: setInfoWindowasset } = useActions(assetinfowindowlogic);

	const handle_focus = (existing_tracker) => {
		const pos = existing_tracker.positions[0];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			global.gmap.setZoom(15);
		}
	}

	const includes_mobile_assets_on_map = (mobile_asset) => {
		let flag = assets.find((item) => {
			return item._id === mobile_asset._id;
		});
		if (flag === undefined) {
			return false;
		}
		return true;
	}

	const handle_visible = (mobile_asset) => {
		if (includes_mobile_assets_on_map(mobile_asset)) {
			removeOne(mobile_asset);
		} else {
			addOne(mobile_asset);
			handle_focus(mobile_asset.beacon);
			setInfoWindowasset(mobile_asset);
			setHistory([])
		}
	}

	const handleFetchNewPosition = () => {
		fetchUpdatedPosition([row], new Date())
	}


	return (
		<div id={'rnd-ignore-drag'}>

			{
				row.beacon && row.beacon.positions && row.beacon.positions.length > 0
					?
					<>
						{
							includes_mobile_assets_on_map(row)
								?
								<>
									<Tooltip title='Hide'>
										<IconButton
											onClick={() => {
												handle_visible(row);
											}}
											size='small'
										>
											<VisibilityOffIcon />
											<Typography>Hide</Typography>

											{/* <CenterFocusStrongIcon /> */}
										</IconButton>
									</Tooltip>
									<Tooltip title='Focus on map'>
										<IconButton onClick={() => {
											handle_focus(row.beacon);
										}}
											size='small'
										>
											<CenterFocusStrongIcon
											/>
											<Typography>Zoom</Typography>

										</IconButton>
									</Tooltip>
								</>
								:
								<>
									<Tooltip title='Show'>
										<IconButton onClick={() => {
											handle_visible(row);
										}}
											size='small'
										>
											<VisibilityIcon />
											<Typography>Show</Typography>

											{/* <CenterFocusStrongIcon /> */}
										</IconButton>
									</Tooltip>
									<IconButton disabled
										size='small'
									>
										<CenterFocusStrongIcon
										/>
										<Typography>Zoom</Typography>
									</IconButton>
								</>
						}
					</>
					:
					<>
						<Tooltip title='Asset does not have a position'>
							<IconButton disabled
								size='small'
							>
								<VisibilityIcon
								/>
								<Typography>Show</Typography>
							</IconButton>
						</Tooltip>
						<Tooltip title='Asset does not have a position'>
							<IconButton disabled
								size='small'
							>
								<CenterFocusStrongIcon
								/>
								<Typography>Zoom</Typography>
							</IconButton>
						</Tooltip>
					</>
				// <Button disabled variant="contained" color="primary" onClick={() => {
				// 	// edit(row);
				// 	console.log('focus clicked!');
				// }}>
				// 	No Tracker
				// </Button>
			}
			<Tooltip title='Manully fetch latest position'>
				<IconButton
					size='small'
					onClick={handleFetchNewPosition}
				>
					<RefreshIcon
					/>
				</IconButton>
			</Tooltip>
		</div>

	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
